import { getTrackdeskParams } from "../Utils/GetTrackDeskParams";

const APP_BASE_URL = process.env.NODE_ENV === 'development' 
    ? "http://localhost:3000" 
    : "https://www.easyimagetotext.com";

const trackDeskQuery = getTrackdeskParams();

const rawReturnUrlWeekly = `${APP_BASE_URL}/payment-success${trackDeskQuery}&plan=pro-weekly`;
const rawReturnUrlMonthly = `${APP_BASE_URL}/payment-success${trackDeskQuery}&plan=pro-monthly`;
const rawReturnUrlYearly = `${APP_BASE_URL}/payment-success${trackDeskQuery}&plan=pro-yearly`;

const encodedReturnUrlWeekly = encodeURIComponent(rawReturnUrlWeekly);
const encodedReturnUrlMonthly = encodeURIComponent(rawReturnUrlMonthly);
const encodedReturnUrlYearly = encodeURIComponent(rawReturnUrlYearly);
    
export const pricingData = [{
    plan: "Free",
    features: {
        imageSizeLimit: '5MB',
        usageLimit: '5'
    }
}, {
    plan: "Pro Monthly",
    rate: "129",
    foreignRate: '4',
    currency: "INR",
    features: {
        imageSizeLimit: '30MB',
        usageLimit: 'Unlimited',
        validity: '30 days'
    },
    lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/12b8ae12-05d3-4869-b1d7-190990c84939?embed=1`,
    lemonSqueezyTestLink: `https://easyimagetotext.lemonsqueezy.com/buy/290d3ea4-133f-44f4-bd67-cfe406665a57?embed=1`
}, {
    plan: "Pro Yearly",
    rate: "999",
    foreignRate: '33',
    currency: "INR",
    features: {
        imageSizeLimit: '30MB',
        usageLimit: 'Unlimited',
        validity: '365 days'
    },
    lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/21800aa2-096d-426f-97ad-d53b6c241e89?embed=1&enabled=844559%2C844560`,
    lemonSqueezyTestLink: `https://easyimagetotext.lemonsqueezy.com/buy/f26f7a63-dc73-439a-b5d2-e6234df1b21e?embed=1&enabled=805232%2C805233`
}]